import { gql } from '@apollo/client'

export default gql`
    mutation completeOrderProgress($order: OrderDataInput!, $pdf: PDFDataInput!, $vzfSummaryData: VZFPDFData!) {
        completeOrderProgress(order: $order, pdf: $pdf, vzfSummaryData: $vzfSummaryData) {
            success
            orderNumber
        }
    }
`
